import { storeCreator } from '@/utils/store/store.utils';

interface State {
  highlightedPaymentMethodId?: string;
  highlightedPaymentMethodIds?: string[];
  setHighlightedPaymentMethodId: (value: string) => void;
  setHighlightedPaymentMethodIds: (value: string[]) => void;
  reset: () => void;
}

const useHighlightedPaymentMethodStore = storeCreator<State>((set) => ({
  highlightedPaymentMethodId: undefined,
  highlightedPaymentMethodIds: undefined,

  setHighlightedPaymentMethodId: (value: string) => set((state) => ({
    ...state,
    highlightedPaymentMethodId: value,
  })),

  setHighlightedPaymentMethodIds: (value: string[]) => set((state) => ({
    ...state,
    highlightedPaymentMethodIds: value,
  })),

  reset: () => set((state) => ({
    ...state,
    highlightedPaymentMethodId: undefined,
    highlightedPaymentMethodIds: undefined
  })),
}));

export default useHighlightedPaymentMethodStore;
